import { render, staticRenderFns } from "./association.vue?vue&type=template&id=16e4a3d2&scoped=true&"
import script from "./association.vue?vue&type=script&lang=js&"
export * from "./association.vue?vue&type=script&lang=js&"
import style0 from "./association.vue?vue&type=style&index=0&id=16e4a3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4a3d2",
  null
  
)

export default component.exports